"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = __importDefault(require("../store"));
const markMessagesAsReadServerSync_1 = __importDefault(require("../actions/chats/markMessagesAsReadServerSync"));
const SYNC_DELAY_MS = 3000;
class MarkAsReadHandler {
    constructor() {
        this.pending = null;
        this.markRead = (chatId, messageIds) => {
            if (this.pending) {
                if (this.pending.chatId !== chatId) {
                    this.updateServer();
                }
                else {
                    // Clear the current timeout and start waiting again, so we flush to the server once no new messages are
                    // marked as read for SYNC_DELAY_MS
                    clearTimeout(this.pending.timeoutId);
                    this.pending.timeoutId = setTimeout(() => this.updateServer(), SYNC_DELAY_MS);
                }
            }
            if (!this.pending) {
                this.pending = {
                    chatId,
                    messageIds: new Set(),
                    timeoutId: setTimeout(() => this.updateServer(), SYNC_DELAY_MS)
                };
            }
            for (const messageId of messageIds) {
                this.pending.messageIds.add(messageId);
            }
        };
        this.updateServer = () => {
            const pending = this.pending;
            if (!pending || !pending.messageIds.size)
                return;
            const ordered = Array.from(pending.messageIds).sort();
            const ranges = [];
            let current = null;
            for (const messageId of ordered) {
                if (!current) {
                    current = [messageId, messageId];
                }
                else if (messageId === current[1] + 1) {
                    current[1] = messageId;
                }
                else {
                    ranges.push(current);
                    current = [messageId, messageId];
                }
            }
            if (current) {
                ranges.push(current);
            }
            ranges.forEach(r => store_1.default.dispatch(markMessagesAsReadServerSync_1.default(pending.chatId, r[0], r[1])));
            this.pending = null;
        };
    }
}
const handler = new MarkAsReadHandler();
exports.default = handler;
